import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function StoreLayout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-black" data-id="element-695" data-mp="227vnd92eg35g">
      <Navbar data-id="element-696" data-mp="1o8vxjy35hi7p" />
      <main className="flex-1" data-id="element-697" data-mp="1o8cpra77sa7e">
        <Outlet data-id="element-698" data-mp="1o82zrmm6631p" />
      </main>
      <Footer data-id="element-699" data-mp="1oaywx8q70np3" />
    </div>;
}